export const getUserMenuPermission = (menuId) => {
  const permissionData = sessionStorage.getItem("userMenuPermissions");

  if (!permissionData) {
    return {
      isInsert: false,
      isUpdate: false,
      isDelete: false,
      isView: false,
    };
  }

  if (permissionData === "ALL") {
    return {
      isInsert: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    };
  }

  const permissions = JSON.parse(permissionData || "[]");

  const findPermission = permissions.find(
    (item) => Number(item.menuId) === Number(menuId)
  );

  if (findPermission) {
    return {
      isInsert: findPermission.isInsert,
      isUpdate: findPermission.isUpdate,
      isDelete: findPermission.isDelete,
      isView: findPermission.isView,
    };
  }

  return {
    isInsert: false,
    isUpdate: false,
    isDelete: false,
    isView: false,
  };
};
